<header class="flex items-center justify-between h-14 px-4 bg-white border-b border-neutral-200 shadow-sm">
  <!-- Left: Menu toggle + Logo -->
  <div class="flex items-center gap-3">
    @if (menuToggleEnabled) {
      <button (click)="toggleMenu()" class="p-2 text-neutral-500 hover:text-neutral-700 hover:bg-neutral-100 rounded-lg transition-colors" aria-label="Toggle navigation menu">
        <i class="fa-solid fa-bars"></i>
      </button>
    }
    <a class="app-logo cursor-pointer" (click)="toggleLogo()">
      <img src="assets/images/Statement-zen.svg" alt="Statement Zen" class="h-10 w-[220px] object-contain" />
    </a>
  </div>

  <!-- Right: User panel -->
  <div class="flex items-center gap-2">
    <app-user-panel [menuItems]="userMenuItems"></app-user-panel>
  </div>
</header>
